import "./index.css";
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
var Spacer = function Spacer(_ref) {
  var size = _ref.size;
  return jsx("div", {
    className: classNames('cds-spacer', "cds-spacer--".concat(size))
  });
};
export { Spacer };